import usePaginas from "@/hooks/usePaginas";
import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

export default function BreadcrumbTitulo({ selected, ...props }) {
  const { t } = useTranslation();
  const { paginas, paginasPorSubgrupo } = usePaginas();
  const paginaAtual = paginas.find((p) => p.label === selected);
  const subgrupoAtual = paginaAtual?.subgrupo ?? false;
  const paginasDoGrupo = paginasPorSubgrupo[subgrupoAtual] ?? [];

  return (
    <Breadcrumb style={{ fontSize: 13 }} {...props}>
      <Breadcrumb.Item href="/home">
        <Tooltip title="Home" placement="bottom">
          <HomeOutlined style={{ fontSize: 13 }} />
        </Tooltip>
      </Breadcrumb.Item>

      {/* Item de título do subgrupo */}
      {subgrupoAtual && <Breadcrumb.Item>{t(subgrupoAtual ?? "Outros")}</Breadcrumb.Item>}

      {/* Título e páginas dentro do subgrupo */}
      <Breadcrumb.Item menu={subgrupoAtual && { items: paginasDoGrupo, triggerSubMenuAction: "click" }} dropdownProps={{ placement: "bottomLeft", trigger: ["click"] }} style={{ cursor: subgrupoAtual && "pointer" }}>
        {selected}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}
